import React from 'react';
import './SchedulesList.scss';
import Icon from "antd/lib/icon";
import Info from "../../Custom UI/Info/Info";
import {toast} from "react-toastify";
import i18next from "i18next";
import DynamicList from "../../Lists/DynamicList/DynamicList";
import {NOTIFY_OPTS} from "../../constants/Notifiers";
import {Translation} from "react-i18next";
import LabeledSwitch from "../../Custom UI/LabeledInputs/LabeledSwitch/LabeledSwitch";
import ScheduleModal from "../../Modals/ScheduleModal/ScheduleModal";
import {formatUserName} from "../../Helpers/AdminHelpers";
import {roleForCompany} from "../../Helpers/CompanyHelpers";
import ConfirmationModal from "../../Modals/ConfirmationModal/ConfirmationModal";
import {momentFromDateTime} from "../../Helpers/DateHelpers";
import {errorMessageFromServerError} from "../../Helpers/Helpers";
import {scheduleIsLocked, scheduleLastUpdatedByUser, scheduleVersionNumber} from "../../Helpers/ScheduleHelpers";

const notifyScheduleRemovedError = (aError) => toast(i18next.t('SCHEDULE_REMOVED_ERROR', {aError:aError}), NOTIFY_OPTS.autoClose);
const notifyScheduleRemovedSuccess = () => toast(i18next.t('SCHEDULE_REMOVED'), NOTIFY_OPTS.autoClose);

export default class SchedulesList extends React.Component {
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      shouldReload:false,
      showLive:true,
      showDeactivated:true,
      scheduleToRemove:null,
      selectedSchedule:null,
      scheduleToReplace:null,
      showScheduleModal:false
    };
  }
  
  renderScheduleStatus(aSchedule){
    let locked = scheduleIsLocked(aSchedule, this.props.user);
    let status = aSchedule.deleted_at ? i18next.t('DEACTIVATED') : i18next.t('LIVE');
    let version = scheduleVersionNumber(aSchedule, false);
    let lastUpdatedByUser = scheduleLastUpdatedByUser(aSchedule);
    
    if(!aSchedule.deleted_at){
      if(version === 0){
        status = i18next.t('DRAFT');
      }
      else{
        status += ' (' + version.toString() + ')'
      }
    }
    return (
      <div className="survey-version-collection-cell-status">
        {locked ?
          <div className="survey-version-collection-cell-locked">
            <img alt='adminLocked'
                 src='/imgs/app/admin-locked.svg'
                 className="survey-version-collection-cell-locked-image"
                 style={{width:'30px', height:'30px'}}
            />
            
            <Info message={i18next.t('LOCKED_BY_ADMIN', {aName:formatUserName(lastUpdatedByUser)})}>
              <div className="patient-tools-notes-popover-button">
                <Icon type="ellipsis"/>
              </div>
            </Info>
          </div>
          :
          <div>
            {status}
          </div>
        }
      </div>
    );
  }
  
  // Render
  
  render(){
    const {user, group, company, patient, languages, saveSchedule, fetchSchedule, fetchSchedules, removeSchedule, publishSchedule,
      saveScheduleTrigger, createPaymentTrigger, removePaymentTrigger, updatePaymentTrigger, removeScheduleTrigger,
      fetchAppAdditionalColumns, fetchQuestionsForSurveyById, fetchSurveyVersionCollections,
      fetchScheduleVersion, fetchScheduleVersionsForSchedule, fetchQuestionsForSurveyByReference, showGroups = true} = this.props;
    const {shouldReload, showLive, showDeactivated, scheduleToRemove, selectedSchedule, scheduleToReplace, showScheduleModal} = this.state;
    
    const role = roleForCompany(company);
    const permissions = ['admin', 'admin_level_2', 'admin_level_4', 'admin_level_12'];
    const editPermissions = ['admin', 'admin_level_4'];
    
    let columnsArray = [];
    columnsArray.push({key:'name', columnWeight:2, columnNameKey:'TITLE', propertiesArray:['name'], sortKey:'name'});
    
    if(showGroups){
      columnsArray.push({key:'groups', columnWeight:3, columnNameKey:'GROUPS', propertiesArray:['draft_schedule_version', 'groups'], sortKey:'groups', valueFormatter:(aGroups) => {
          let returnValue = '';
      
          if(aGroups && aGroups.length > 0){
            for(let group of aGroups){
              returnValue += group.name + ', ';
            }
            returnValue = returnValue.substring(0, returnValue.length - 2);
          }
          return returnValue;
        }});
    }
    columnsArray.push({key:'updated_at', columnWeight:2, columnNameKey:'SURVEY_DATE', propertiesArray:['updated_at'], sortKey:'updated_at', valueFormatter:(aDate) => momentFromDateTime(aDate)});
    columnsArray.push({key:'draft_version', columnWeight:1, columnNameKey:'DRAFT_VERSION', sortKey:'draft_version', templateCell:(aSchedule) => scheduleVersionNumber(aSchedule)});
    columnsArray.push({key:'live_version', columnWeight:1, columnNameKey:'LIVE_VERSION', sortKey:'live_version', templateCell:(aSchedule) => this.renderScheduleStatus(aSchedule)});
    
    let menuItemsArray = [];
    menuItemsArray.push({title:'EDIT', clickAction:(aObject) => this.setState({selectedSchedule:aObject, showScheduleModal:true})});
    
    menuItemsArray.push({title:'DEACTIVATE', clickAction:(aObject) => this.setState({scheduleToRemove:aObject}), isValid:(aSchedule) => Boolean(aSchedule) && !aSchedule.deleted_at});
    
    return (
      <div className="schedules-list">
        {permissions.includes(role) ?
          <DynamicList id="schedules-list"
                       didReload={() => this.setState({shouldReload:false})}
                       headerView={
                         <div className="schedules-list-filters">
                           <LabeledSwitch className="schedules-list-filter"
                                          bold={false}
                                          label={<Translation>{ (t, { i18n }) => t('LIVE') }</Translation>}
                                          checked={showLive}
                                          onChange={(isChecked) => this.setState({showLive:isChecked, shouldReload:true})}
                                          infoBlurb={i18next.t('SHOW_ACTIVE_SCHEDULES')}
                                          popoverPlacement={"top"}
                                          showCheckedLabels={false}
                           />
                           <LabeledSwitch className="schedules-list-filter"
                                          bold={false}
                                          label={<Translation>{ (t, { i18n }) => t('DEACTIVATED') }</Translation>}
                                          checked={showDeactivated}
                                          onChange={(isChecked) => this.setState({showDeactivated:isChecked, shouldReload:true})}
                                          infoBlurb={i18next.t('SHOW_DEACTIVATED_SCHEDULES')}
                                          popoverPlacement={"top"}
                                          showCheckedLabels={false}
                           />
                         </div>
                       }
                       menuCancel={() => this.setState({selectedSchedule:null})}
                       fetchObjects={(aLimit, aOffset, aSearchString, aSelectedColumn, aIsAscending) => fetchSchedules(aLimit, aOffset, aSearchString, patient ? patient.id : null, group ? group.id : null, showLive, showDeactivated, columnsArray[aSelectedColumn] ? columnsArray[aSelectedColumn].sortKey : null, aIsAscending)}
                       columnsArray={columnsArray}
                       shouldReload={shouldReload}
                       canSortList={true}
                       showSortIndicators={false}
                       explanationKey='SCHEDULES_EXPLANATION'
                       menuItemsArray={editPermissions.includes(role) ? menuItemsArray : undefined}
                       minColumnWidth={100}
                       objectToReplace={scheduleToReplace}
                       totalObjectsKey='TOTAL_SCHEDULES'
                       addButtonClicked={patient && editPermissions.includes(role) ? () => this.setState({selectedSchedule:null, showScheduleModal:true}) : null}
                       responseTotalKeysArray={['data', 'data', 'schedules', 'total']}
                       finishedReplacingObject={() => this.setState({scheduleToReplace:null})}
                       responseObjectKeysArray={['data', 'data', 'schedules', 'schedules']}
          />
          :
          <div className="no-information-text">
            {i18next.t('SCHEDULES_BLOCKED')}
          </div>
        }
        
        {showScheduleModal ?
          <ScheduleModal open={showScheduleModal}
                         user={user}
                         close={() => this.setState({showScheduleModal:false, selectedSchedule:null})}
                         company={company}
                         patient={patient}
                         schedule={selectedSchedule}
                         languages={languages}
                         saveSchedule={saveSchedule}
                         fetchSchedule={fetchSchedule}
                         fetchSchedules={fetchSchedules}
                         publishSchedule={publishSchedule}
                         didUpdateSchedule={(aSchedule) => this.setState({scheduleToReplace:aSchedule, shouldReload:true})}
                         saveScheduleTrigger={saveScheduleTrigger}
                         createPaymentTrigger={createPaymentTrigger}
                         removePaymentTrigger={removePaymentTrigger}
                         updatePaymentTrigger={updatePaymentTrigger}
                         removeScheduleTrigger={removeScheduleTrigger}
                         fetchAppAdditionalColumns={fetchAppAdditionalColumns}
                         fetchQuestionsForSurveyById={fetchQuestionsForSurveyById}
                         fetchSurveyVersionCollections={fetchSurveyVersionCollections}
                         fetchScheduleVersion={fetchScheduleVersion}
                         fetchScheduleVersionsForSchedule={fetchScheduleVersionsForSchedule}
                         fetchQuestionsForSurveyByReference={fetchQuestionsForSurveyByReference}
          />
          :
          null
        }
        
        <ConfirmationModal title={i18next.t('DEACTIVATED_SCHEDULE')}
                           isOpen={scheduleToRemove !== null}
                           reject={() => this.setState({scheduleToRemove:null})}
                           confirm={() => {
                             removeSchedule(scheduleToRemove.id).then((newResult) => {
                               notifyScheduleRemovedSuccess();
                               this.setState({scheduleToRemove:null, shouldReload:true});
                             }, (newError) => {
                               notifyScheduleRemovedError(errorMessageFromServerError(newError));
                               this.setState({scheduleToRemove:null});
                             })
                           }}
                           description={i18next.t('REMOVE_SCHEDULE_DESCRIPTION', {aName:scheduleToRemove ? scheduleToRemove.name : ''})}
        />
      </div>
    )
  }
}
